export default __webpack_public_path__ + "images/5f29bc698946cd6bf61795b70352f4da-heart.png";